// authApi.js
import { API_CONFIG} from "../../../utils/api-config";
import fetchWithAuth from "../../../utils/apiAthurization";

export const StoreStockTransfer = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/stock-transfers`,'POST',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetStockTransfers = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/stock-transfers`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "Categories fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetStockTransferById = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/stock-transfers/${id}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const UpdateStockTransfer = async (id,data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/stock-transfers/${id}`,'PATCH',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const DeleteStockTransfer = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/stock-transfers/${id}`,'DELETE'
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};